import {
  type PaginationParam,
  type PaginationResponse,
  mapPaginationResponse,
} from "../types/paginationResponse";
import {
  type SuratJalanDetail,
  type SuratJalanListItem,
  type SuratJalanSearchFilters,
  mapSuratJalanDetailResponse,
  mapSuratJalanListResponse,
} from "../types/suratJalan";
import { buildPaginationQuery } from "../utils/pagination";
import api from "./axios";

export interface SearchSuratJalanResponse {
  suratJalans: SuratJalanListItem[];
  pagination: PaginationResponse;
}

export const searchSuratJalanApi = async (
  filters?: SuratJalanSearchFilters,
  pagination?: PaginationParam,
): Promise<SearchSuratJalanResponse> => {
  const queryString = buildPaginationQuery(pagination);
  const response = await api.post<any>(`/api/v1/suratJalan/search${queryString}`, filters ?? {});
  return {
    suratJalans: mapSuratJalanListResponse(response.data),
    pagination: mapPaginationResponse(response.data.data.pagination),
  };
};

export const getSuratJalanByIdApi = async (id: string): Promise<SuratJalanDetail> => {
  const response = await api.get<any>(`/api/v1/suratJalan/${id}`);
  return mapSuratJalanDetailResponse(response.data);
};

export const verifySuratJalanApi = async (id: string): Promise<SuratJalanDetail> => {
  const response = await api.post<any>(`/api/v1/suratJalan/${id}/verify`, {});
  return mapSuratJalanDetailResponse(response.data);
};

export const approveSuratJalanApi = async (id: string): Promise<SuratJalanDetail> => {
  const response = await api.post<any>(`/api/v1/suratJalan/${id}/approve`, {});
  return mapSuratJalanDetailResponse(response.data);
};

export const requestSuratJalanRevisionApi = async (
  id: string,
  note: string,
): Promise<SuratJalanDetail> => {
  const response = await api.post<any>(`/api/v1/suratJalan/${id}/requestRevision`, { note });
  return mapSuratJalanDetailResponse(response.data);
};
